import { useModal } from 'components/Modal';
import { useMutation } from 'query';
import { moreInfo } from 'scenes/FinancePage/IO/data/queryKeyFactory';
import { moreInfoIO } from 'scenes/FinancePage/IO/sources';

import ConfirmDialog from './components/ConfirmDialog';

export const useMoreInfo = () => {
  const [showConfirmDialog] = useModal(ConfirmDialog);

  const approveMutation = useMutation(moreInfo(), moreInfoIO, {
    refresh: true,
    successMessage: () => 'More info requested',
  });

  const handleAction = ({
    id,
    businessPartner,
    period,
    createdBy,
    parentIo,
  }: any) => {
    showConfirmDialog({
      modalTitle: 'Request more info',
      businessPartner,
      period,
      createdBy,
      parentIo,
    }).then(({ comment, reasons }: { comment: string; reasons: number[] }) =>
      approveMutation.mutateAsync({ id, comment, reasons })
    );
  };

  return [handleAction, approveMutation];
};
